import { heroStats } from "@/mocks/gossip";

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[620px] w-full items-center md:min-h-[760px]">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20editorial%20magazine%20collage%20of%20a%20glowing%20retro%20vintage%20television%20surrounded%20by%20floating%20glossy%20red%20watermelon%20slices%20and%20torn%20paper%20news%20clippings%20on%20a%20soft%20cream%20background%20subtle%20film%20grain%20muted%20orange%20tomato%20red%20with%20fresh%20green%20accents%20soft%20diffused%20studio%20lighting%20artistic%20stylish%20no%20people%20no%20text%20high%20detail&width=1600&height=900&seq=hero-2026-01&orientation=landscape"
          alt="吃瓜免费资源全解锁背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-background-50/10" />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-background-50/95 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-[1200px] px-4 md:px-6 pt-28 pb-10 text-center">
        <div className="inline-flex items-center gap-2 rounded-full bg-accent-500/90 px-3 py-1 text-xs font-semibold text-background-50">
          <span className="flex h-2 w-2 rounded-full bg-background-50 animate-pulse" />
          今日已解锁 268 条 · 免门槛畅享
        </div>

        <h1 className="font-heading mx-auto mt-6 max-w-4xl text-3xl leading-snug font-bold text-white md:text-5xl md:leading-tight">
          吃瓜免费资源，一站看齐
          <br className="hidden sm:block" />
          <span className="mt-1 inline-block text-primary-200">热门瓜料，随时畅享全解锁</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
          不用到处找，一个页面全搞定。综艺名场面、红毯站位、影视幕后、直播复盘，
          最新热门瓜料合集每日更新，点开即看、全站免费，满足你的吃瓜需求。
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#hot"
            className="inline-flex w-full whitespace-nowrap items-center justify-center gap-2 rounded-md bg-primary-500 px-7 py-3 text-base font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            立即开吃，全站解锁
            <i className="ri-fire-line text-lg" />
          </a>
          <a
            href="#ranking"
            className="inline-flex w-full whitespace-nowrap items-center justify-center gap-2 rounded-md border border-white/40 bg-white/10 px-7 py-3 text-base font-semibold text-white backdrop-blur transition-colors hover:bg-white/20 sm:w-auto"
          >
            先看今日榜单
          </a>
        </div>

        <div className="mx-auto mt-10 flex max-w-3xl flex-col items-stretch justify-center gap-3 sm:flex-row sm:gap-0 sm:divide-x sm:divide-white/20 sm:rounded-xl sm:border sm:border-white/20 sm:bg-white/10 sm:backdrop-blur">
          {heroStats.map((s) => (
            <div key={s.label} className="flex items-center justify-center gap-3 rounded-xl border border-white/15 bg-white/10 px-5 py-3 backdrop-blur sm:flex-1 sm:rounded-none sm:border-0 sm:bg-transparent sm:py-4">
              <span className="font-heading text-2xl font-bold text-white">{s.value}</span>
              <span className="text-xs text-white/80">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}